import type { MoneyString } from '@/lib/money';

export type BudgetSummary = {
  id: number;
  name: string;
  entity_id: number | null;
  entity_name: string | null;
  is_consolidated: boolean;
  period_type: string;
  period_start: string;
  period_end: string;
  status: string;
  items_count: number;
  expense_limit: MoneyString | null;
};

export type BudgetRow = {
  id: number;
  dimension: string;
  category_id: number | null;
  label: string;
  /** RN-91: a tendência linear só vale para `variavel`. */
  behavior: string;
  is_essential: boolean;

  /** RF-ORC-03 — as sete colunas, sempre juntas. */
  planned: MoneyString;
  actual: MoneyString;
  committed: MoneyString;
  projected: MoneyString;
  difference: MoneyString;
  consumption_percent: number | null;
  trend: MoneyString;

  is_over_budget: boolean;
  alerts_fired: Record<string, string | null>;
};

export type BudgetDetail = {
  budget: {
    id: number;
    name: string;
    entity_id: number | null;
    entity_name: string | null;
    is_consolidated: boolean;
    period_type: string;
    period_start: string;
    period_end: string;
    status: string;
    income_target: MoneyString | null;
    expense_limit: MoneyString | null;
    savings_target: MoneyString | null;
  };
  progress: {
    reference_date: string;
    elapsed_days: number;
    total_days: number;
    remaining_days: number;
    has_ended: boolean;
    has_started: boolean;
  };
  items: BudgetRow[];
  totals: {
    planned: MoneyString;
    actual: MoneyString;
    committed: MoneyString;
    projected: MoneyString;
    difference: MoneyString;
    consumption_percent: number | null;
    trend: MoneyString;
    items_over_budget: number;
  };
  /** RN-93: o DRE conta isto, o orçamento não. Reportado para a diferença ser explicável. */
  managerial_excluded: MoneyString;
  note: string;
};

/** Faixa de consumo → cor. 100% não é "quase lá", é estouro. */
export function consumptionTone(percent: number | null): 'ok' | 'atencao' | 'limite' | 'estouro' {
  if (percent === null) return 'ok';
  if (percent >= 100) return 'estouro';
  if (percent >= 90) return 'limite';
  if (percent >= 70) return 'atencao';
  return 'ok';
}
